import types from './types';

const setDlistLoading = (isLoading) => ({
  type: types.EPN_DLIST_SET_LOADING,
  payload: isLoading
});

const setDlistData = (data) => ({
  type: types.EPN_DLIST_SET_DATA,
  payload: data
});

const setDlistError = (error) => ({
  type: types.EPN_DLIST_SET_ERROR,
  payload: error
});

const clearDlistData = () => ({
  type: types.EPN_DLIST_CLEAR_DATA
});

export default {
  setDlistLoading,
  setDlistData,
  setDlistError,
  clearDlistData
};
